<header [ngStyle]="headerStyle">
  <div>
    ให้ของขวัญ... <span class="big-font">"{{ data.userInfo.name }}"</span>
  </div>
  <app-user-economy [amount]="userInfo.points"></app-user-economy>
</header>
<mat-dialog-content>
  @if (error) {
    <div class="error-container">
      <app-error-message [message]="error" [fullWidth]="true"></app-error-message>
    </div>
  }

  <app-loading-shade [isLoading]="isLoadingGift"></app-loading-shade>

  <div class="grid-container">
    @for (gift of gifts; track gift) {
      <app-gift
        [gift]="gift"
        [theme]="data.theme"
        mode="shop"
        class="click-able"
        [isSelected]="gift.id === selectedGiftId"
        (click)="select(gift.id)"
      ></app-gift>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [disabled]="isSending" mat-dialog-close>ยกเลิก</button>
  <button
    mat-raised-button
    [appThemedButton]="data.theme"
    [disabled]="!selectedGiftId || isSending"
    (click)="submit()"
  >
    <span class="material-icons">card_giftcard</span>
    ส่งของขวัญ
  </button>
</mat-dialog-actions>
